export default __webpack_public_path__ + "static/media/male.f992a1cf.png";